import {imageBadgeStyles} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageBadge";
import { css } from "styled-components";


imageBadgeStyles.imageContainer={
    css:css`
       justify-content: flex-start;
    `
}  

imageBadgeStyles.imageItem={
    css: css`
    padding: 5px;
    justify-content: flex-start;
`,
}